import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-115">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-116">
        <FadeIn direction="right" data-id="element-117">
          <div className="space-y-6" data-id="element-118">
            <div className="inline-block bg-cream-dark text-cinnamon font-semibold px-4 py-1.5 rounded-full text-sm tracking-wide uppercase mb-2" data-id="element-119">
              Plan Detox de Azúcar 7 Días
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-dark-brown" data-id="element-120">
              ¿EL BOTÓN DE TU PANTALÓN NO CERRÓ ESTE LUNES POR LA MAÑANA?
            </h1>
            <p className="text-xl md:text-2xl text-dark-brown/80 font-medium leading-relaxed" data-id="element-121">
              Desinflama tu abdomen y recupera tu energía en solo 7 días sin
              dejar de comer rico ni abandonar tu café con leche.
            </p>
            <div className="pt-4" data-id="element-122">
              <Button onClick={() => document.getElementById('cta-section')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-123">
                QUIERO MI PLAN DETOX AHORA
              </Button>
            </div>
          </div>
        </FadeIn>

        <FadeIn direction="left" delay={0.2} data-id="element-124">
          <div className="relative" data-id="element-125">
            <div className="absolute inset-0 bg-cinnamon/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-126"></div>
            <img src="https://cdn.magicpatterns.com/uploads/febfaTaMv6QFd9hVgg4yG9/7_dias.png" alt="Plan Detox de Azúcar 7 Días en varios dispositivos" className="rounded-3xl shadow-2xl w-full object-cover" data-id="element-127" />
          </div>
        </FadeIn>
      </div>
    </section>;
}